import { bannersService as banners } from './banners/banners.service';
import { customersService as customer } from './customers/customers.service';
import { branchesService as branches } from './distributors/branches.service';
import { downloadsService as downloads } from './downloads-uploads/downloads.service';
import { uploadsService as uploads } from './downloads-uploads/uploads.service';
import { exportService as exports } from './exports/exports.service';
import { g2mFunctionsService as g2mFunctions } from './g2m-functions/g2m-functions.service';
import { maintenanceService as maintenance } from './maintenance/maintenance.service';
import { masterEntitiesService as masterEntities } from './master-entities/master-entities.service';
import { hierarchyService as hierarchy } from './navigation/hierarchy.service';
import { navigationService as navigation } from './navigation/navigation.service';
import { ordersService as orders } from './orders/orders.service';
import { productsService as products } from './products/products.service';
import { promotionsService as promotions } from './promotions/promotions.service';
import { shortcutsService as shortcuts } from './shortcuts/shortcuts.service';
import { staticPagesService as staticPages } from './static-pages/static-pages.service';
import { suggestedProductsService as suggestedProducts } from './suggested-product/suggested-product.service';
import { uploadFilesService as uploadFiles } from './upload-files/upload-files.service';
import { usersService as users } from './users/users.service';
import { yapeService as yape } from './yape/yape.service';

export const apiService = {
  customer,
  downloads,
  exports,
  g2mFunctions,
  hierarchy,
  maintenance,
  masterEntities,
  navigation,
  orders,
  products,
  promotions,
  staticPages,
  suggestedProducts,
  branches,
  banners,
  shortcuts,
  uploadFiles,
  users,
  uploads,
  yape,
};
